import { render, staticRenderFns } from "./SetData.vue?vue&type=template&id=474578cc&"
import script from "./SetData.vue?vue&type=script&lang=js&"
export * from "./SetData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports